import { useDispatch } from "react-redux";
import { addHotspotFromUI } from "../../../redux";
import { Button } from "antd";
import AddLineIcon from "remixicon-react/AddLineIcon";
import { iconSize } from "../../../config";

export function AddHotspot() {
  const dispatch = useDispatch();
  const addMoreHotspots = () => {
    dispatch(addHotspotFromUI());
  };

  return (
    <Button
      type="text"
      onClick={addMoreHotspots}
      icon={<AddLineIcon size={iconSize} />}
    >
      Add hotspot
    </Button>
  );
}
